import { Component, OnInit, Inject } from '@angular/core';
import { CommonService } from '../../services';
import { AuthService } from '../../services/auth.service';
import { MyAccountService } from '../../services/myAccount.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EnableMfaComponent } from '../enable-mfa/enable-mfa.component';
import { MfaModel, UserInfoViewModel } from '../../models/account-ledger.model';
import { MfaAuthenticationComponent } from '../mfa-authentication/mfa-authentication.component';

@Component({
  selector: 'app-update-email-mobile',
  templateUrl: './update-email-mobile.component.html',
  styleUrls: ['./update-email-mobile.component.css']
})
export class UpdateEmailMobileComponent implements OnInit {

  loginName: string;
  accountId: string;
  sendMethod: string;
  emailAddress: string;
  mobileNumber: string;
  isEmailExist = false;
  isMobileExist = false;
  updateMfaModel: MfaModel = <MfaModel>{};
  updateUserModel: UserInfoViewModel = <UserInfoViewModel>{};

  constructor(
    private commonService: CommonService,
    private authService: AuthService,
    private myAccountService: MyAccountService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<EnableMfaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.loginName = this.data.loginName;
    this.accountId = this.data.accountId;
    this.emailAddress = this.data.emailAddress;
    this.mobileNumber = this.data.mobileNumber;
    this.sendMethod = this.data.sendMethod;
  }

  updateUserInfo() {

    if (this.sendMethod === 'email') {
      if (!this.emailAddress) {
        this.commonService.implementToast('Please enter email address.', 'Error');
        return;
      }
      if (!this.emailIsValid(this.emailAddress)) {
        this.commonService.implementToast('Invalid email address.', 'Error');
        return;
      }
    } else {
      if (!this.mobileNumber) {
        this.commonService.implementToast('Please enter mobile number.', 'Error');
        return;
      }
    }

    const mfaType = this.sendMethod.charAt(0).toUpperCase();
    this.updateMfaModel.mfaEnabled = mfaType;
    this.updateMfaModel.mobile = this.mobileNumber;
    this.updateMfaModel.email = this.emailAddress;
    this.authService.sendMfaRegistrationCode(this.updateMfaModel).subscribe((res: any) => {
      if (res === true) {
        const dialogRef = this.dialog.open(MfaAuthenticationComponent, {
          width: '400px',
          data: {
            sendMethod: this.sendMethod,
            mobile: this.mobileNumber,
            email: this.emailAddress
          }
        });

        dialogRef.afterClosed().subscribe(result => {
           if (result) {
             this.updateUserModel.loginName = this.loginName;
             this.updateUserModel.accountId = this.accountId;
             if (this.sendMethod === 'email') { this.updateUserModel.email = this.emailAddress; }
             if (this.sendMethod === 'mobile') { this.updateUserModel.mobileNumber = this.mobileNumber; }
             this.myAccountService.UpdateUserProfile(this.updateUserModel).subscribe((data: any) => {
               if (data.status === true) {
                this.commonService.implementToast(`Your ${this.sendMethod} has been updated successfully.`, 'Success');
                const responseMsg = this.sendMethod === 'email' ? this.emailAddress : this.mobileNumber;
                this.dialogRef.close(responseMsg);
               } else {
                this.commonService.implementToast('Unable to update at this moment, please try again later.', 'Error');
               }
             },
             (error: any) => {
               console.error(error);
               this.commonService.implementToast('Unable to update at this moment, please try again later.', 'Error');
             });
           }
        });
      } else {
        this.commonService.implementToast('Unable to send OTP, please try again later.', 'Error');
      }

    },
    (error: any) => {
      console.error(error);
      this.commonService.implementToast('Unable to send OTP, please try again later.', 'Error');
    });
  }

  emailIsValid (email: string): boolean {
    return /\S+@\S+\.\S+/.test(email);
  }

  onCloseClick() {
    this.dialogRef.close(false);
  }
}
